    import React from 'react';
import { Box, Container, Typography, Breadcrumbs, Link } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const PageHeader = ({ 
  title, 
  subtitle, 
  breadcrumbs = [], 
  backgroundImage = null,
  height = '300px' 
}) => {
  return (
    <Box
      sx={{
        position: 'relative',
        height: height,
        background: backgroundImage 
          ? `linear-gradient(rgba(43, 43, 107, 0.85), rgba(43, 43, 107, 0.85)), url(${backgroundImage})`
          : 'linear-gradient(135deg, #2B2B6B 0%, #1a1a4a 100%)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        color: 'white',
        mb: 4,
      }}
    >
      {/* Decorative pattern overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.05,
          backgroundImage: `repeating-linear-gradient(
            45deg,
            transparent,
            transparent 10px,
            rgba(255,255,255,0.1) 10px,
            rgba(255,255,255,0.1) 20px
          )`,
        }}
      />

      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
        {/* Breadcrumbs */}
        {breadcrumbs.length > 0 && (
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" sx={{ color: 'rgba(255,255,255,0.7)' }} />}
            sx={{ mb: 2 }}
          >
            {breadcrumbs.map((crumb, index) => (
              <Link
                key={index}
                href={crumb.href}
                underline="hover"
                sx={{
                  color: index === breadcrumbs.length - 1 
                    ? 'white' 
                    : 'rgba(255,255,255,0.7)',
                  fontSize: '0.875rem',
                  fontWeight: index === breadcrumbs.length - 1 ? 500 : 400,
                  '&:hover': {
                    color: 'white',
                  },
                }}
              >
                {crumb.label}
              </Link>
            ))}
          </Breadcrumbs>
        )}

        {/* Title */}
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '2rem', md: '3rem' },
            fontWeight: 700,
            mb: subtitle ? 2 : 0,
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
          }}
        >
          {title}
        </Typography>

        {/* Subtitle */}
        {subtitle && (
          <Typography
            variant="h5"
            sx={{
              fontSize: { xs: '1rem', md: '1.25rem' },
              fontWeight: 400,
              opacity: 0.95,
              maxWidth: '800px',
            }}
          >
            {subtitle}
          </Typography>
        )}

        {/* Decorative line */}
        <Box
          sx={{
            width: '100px',
            height: '4px',
            background: 'linear-gradient(90deg, #00CED1 0%, #E31E24 100%)',
            mt: 3,
            borderRadius: '2px',
          }}
        />
      </Container>
    </Box>
  );
};

export default PageHeader;